"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var FeaturesContext_1 = require("./FeaturesContext");
var withFeaturesConfigProvider = function (Component, featuresConfigSetter) {
    var FeaturesConfigProvider = function (props) {
        var featureConfig = featuresConfigSetter && featuresConfigSetter(props);
        if (!featureConfig)
            throw 'You need to pass a featuresConfigSetter function to the FeaturesConfigProvider';
        return (React.createElement(FeaturesContext_1.FeaturesContext.Provider, { value: featureConfig },
            React.createElement(Component, __assign({}, props))));
    };
    FeaturesConfigProvider.displayName = "withFeaturesConfigProvider(" + Component.displayName + ")";
    return FeaturesConfigProvider;
};
exports.default = withFeaturesConfigProvider;
//# sourceMappingURL=withFeaturesConfigProvider.js.map